import { useState, useEffect } from 'react';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { toast } from '@navi/web-ui/lib/primitives/Toast';

const cache: Record<string, GenericObject> = {};
const inflight: Record<string, Promise<GenericObject | null>> = {};

const useLottieAnimation = (importFn: () => Promise<{ default: GenericObject }>, key: string) => {
  const [animationData, setAnimationData] = useState<GenericObject | null>(cache[key] ?? null);

  useEffect(() => {
    if (cache[key]) {
      setAnimationData(cache[key]);
      return;
    }

    if (!inflight[key]) {
      inflight[key] = importFn()
        .then(module => {
          cache[key] = module.default;
          return module.default;
        })
        .catch(() => {
          toast.error('Error fetching lottie animation', { type: 'error' });
          return null;
        })
        .finally(() => {
          delete inflight[key];
        });
    }

    inflight[key].then(data => {
      if (data) setAnimationData(data);
    });
  }, [key]);

  return animationData;
};

export default useLottieAnimation;
